import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import { Card, Form, Input, Select, Button, Icon, Modal, message } from "antd";
import Loading from "../../../../components/Loading";
import InputMask from "react-input-mask";
import { createLoadingSelector } from "../../../../store/api/selectors";
import {
  getCompany,
  getCompanies,
  putCompany,
  excluirEmpresa,
} from "../../../actions";
import { clearProductsPisCofings } from "../../Classify/PisCofins/actions";
import { clearProductsIcms } from "../../Classify/Icms/actions";
import {
  maskCnpj,
  normalizeCnpj,
  getEnderecoByCep,
  validarCNPJ,
} from "../../../../helpers/functions";
import { Sessao } from "../../../../helpers/Token";

const planoTeste = Sessao('planoTeste');
const planoRecuperadorLimitado = Sessao('planoRecuperadorLimitado');

const Option = Select.Option;

class Data extends Component {
  state = {
    company: {
      Cnpj: null,
      RazaoSocial: null,
      Ie: null,
      Uf: null,
      Endereco: {
        Rua: null,
        Numero: null,
        Complemento: null,
        Bairro: null,
        Cep: null,
        Municipio: null,
      },
    },

    errosRazaoSocial: null,
    errosCnpj: null,
    errosUF: null,
    errosCep: null,

    disabledButton: true,
    showModalExclusao: false,
    loadingExclusaoEmpresa: false,
    moduloIcms: !!sessionStorage.getItem("icmsModule"),
  };

  componentDidMount() {
    const { props } = this;

    props.getCompany();
    this.setState({ company: props.company });
  }

  componentDidUpdate(prevProps) {
    const {
      props,
      props: {
        match: {
          params: { cnpj },
        },
      },
    } = this;

    if (prevProps.match.params.cnpj !== cnpj) {
      props.getCompany();
    }

    this.setInitialCompany(prevProps);
  }

  setInitialCompany = (prevProps) => {
    const { company } = this.props;

    if (prevProps.company !== company) {
      this.setState({
        company,
        moduloIcms: !!sessionStorage.getItem("icmsModule"),
      });
    }
  };

  formValidate = () => {
    let valido = 0;

    valido = this.validateRazaoSocial(valido);
    valido = this.validateCnpj(valido);
    valido = this.validateUF(valido);

    if (this.state.company && this.state.company.Endereco)
      valido = this.validateCep(valido, this.state.company.Endereco.Cep);

    if (valido !== 0) this.setState({ disabledButton: true });
    else this.setState({ disabledButton: false });

    return valido;
  };

  maxLengthCheck = (numero) => {
    if (numero.target.value.length > numero.target.maxLength) {
      numero.target.value = numero.target.value.slice(
        0,
        numero.target.maxLength
      );
    }
  };

  validateRazaoSocial = (valido) => {
    if (!valido) valido = 0;

    this.setState({ errosRazaoSocial: null });

    const { RazaoSocial } = this.state.company;

    if (!RazaoSocial || RazaoSocial.replaceAll(" ", "").length < 2) {
      valido++;
      this.setState({ errosRazaoSocial: "Razão Social Inválida" });
    }

    return valido;
  };

  validateCnpj = (valido) => {
    if (!valido) valido = 0;

    this.setState({ errosCnpj: null });

    const { Cnpj } = this.state.company;

    if (!Cnpj) {
      valido++;
      this.setState({ errosCnpj: "CNPJ vazio" });
      return valido;
    }

    var cnpj = Cnpj;
    cnpj = cnpj.replaceAll(" ", "");
    cnpj = cnpj.replaceAll(".", "");
    cnpj = cnpj.replaceAll("-", "");
    cnpj = cnpj.replaceAll("/", "");
    cnpj = cnpj.replaceAll("_", "");

    if (!validarCNPJ(cnpj)) {
      valido++;
      this.setState({ errosCnpj: "CNPJ Inválido" });
    }

    return valido;
  };

  validateUF = (valido) => {
    this.setState({ errosUF: null });

    const { moduloIcms } = this.state;
    const { Uf } = this.state.company;

    if (moduloIcms) {
      if (!Uf) {
        valido++;
        this.setState({ errosUF: "UF é obrigatória" });
      }
    }

    return valido;
  };

  validateCep = (valido, value) => {
    this.setState({ errosCep: null });

    if (!valido) valido = 0;

    if (!value && !value.replaceAll("-", "").replaceAll("_", "")) {
      return valido;
    }

    var cep = value.replaceAll("-", "").replaceAll("_", "");

    if (cep && cep.length !== 8) {
      valido++;
      this.setState({ errosCep: "CEP inválido" });
    }

    return valido;
  };

  handleChangeRazaoSocial = (event) => {
    const value = event.target.value;

    this.setState(
      (state) => ({ company: { ...state.company, RazaoSocial: value } }),
      () => this.formValidate()
    );
  };

  handleChangeCnpj = (event) => {
    const value = maskCnpj(normalizeCnpj(event.target.value).substring(0, 14));

    this.setState(
      (state) => ({ company: { ...state.company, Cnpj: value } }),
      () => this.formValidate()
    );
  };

  handleChangeIe = (event) => {
    const value = event.target.value;

    this.setState(
      (state) => ({ company: { ...state.company, Ie: value } }),
      () => this.formValidate()
    );
  };

  handleSelectUF(value) {
    this.setState(
      (state) => ({ company: { ...state.company, Uf: value } }),
      () => this.formValidate()
    );
  }

  handleChangeCep = async (event) => {
    this.setState({ errosCep: null });

    const value = event.target.value;
    let valido = 0;

    await this.setState(
      (state) => ({
        company: {
          ...state.company,
          Endereco: {
            ...state.company.Endereco,
            Cep: value,
          },
        },
      }),
      () => {
        valido = this.formValidate();
      }
    );

    if (
      valido === 0 &&
      value &&
      value.replaceAll("-", "").replaceAll("_", "").length === 8
    ) {
      const data = await getEnderecoByCep(value);

      if (!data || data.erro) {
        this.setState({ errosCep: "CEP inválido" });
        return;
      }

      this.setState((state) => ({
        company: {
          ...state.company,
          Uf: data.uf,
          Endereco: {
            ...state.company.Endereco,
            Municipio: data.localidade,
            Bairro: data.bairro,
            Rua: data.logradouro,
          },
        },
      }));
    }
  };

  handleChange = (e, field) => {
    let value = field ? e : e.target.value;
    const name = field || e.target.name;

    const [nameParent, nameChild] = name.split(".");

    this.setState(
      (state) => ({
        company: {
          ...state.company,
          [nameParent]: !!nameChild
            ? { ...state.company[nameParent], [nameChild]: value }
            : value,
        },
      }),
      () => {
        this.formValidate();
      }
    );
  };

  handleSubmit = async () => {
    const { props } = this;
    const { history } = props;
    const { company } = this.state;

    if (this.formValidate() !== 0) {
      message.error("Existem algum campo inválido!");
      return;
    }

    company.Cnpj = normalizeCnpj(company.Cnpj);
    company.Ie = company.Ie.replaceAll(".", "")
      .replaceAll("-", "")
      .replaceAll("/", "");

    await props.putCompany(company);
    await props.getCompanies();
    history.push(`/empresa/${company.Cnpj}`);
  };

  closeModal = () =>
    this.setState({
      showModalExclusao: false,
    });

  openModal = () =>
    this.setState({
      showModalExclusao: true,
    });

  confirmacaoExcluirEmpresa = () => {
    this.setState({
      loadingExclusaoEmpresa: true,
    });
    const { props } = this;
    const { history } = props;
    this.props.excluirEmpresa(this.state.company.Id, (response) => {
      if (response) {
        props.getCompanies();
        history.push("/recuperacao");
      }
      this.closeModal();

      this.props.clearProductsPisCofings();
      this.props.clearProductsIcms();

      this.setState({
        loadingExclusaoEmpresa: false,
      });
    });
  };

  renderModal = () => {
    return (
      <div>
        {this.state.company.Cnpj && (
          <Modal
            title={`${maskCnpj(this.state.company.Cnpj)} - ${
              this.state.company.RazaoSocial
            }`}
            visible={this.state.showModalExclusao}
            onCancel={this.closeModal}
            onOk={this.confirmacaoExcluirEmpresa}
            okButtonProps={{ loading: this.state.loadingExclusaoEmpresa }}
            cancelButtonProps={{ disabled: this.state.loadingExclusaoEmpresa }}
          >
            <p>
              <strong>
                Atenção: a exclusão de uma empresa implica na exclusão de TODOS
                os dados a ela relacionados.
              </strong>
            </p>
            <br />
            <p>
              O novo cadastro deste mesmo CNPJ só poderá ocorrer após a exclusão
              total dos dados, sendo necessário aguardar a conclusão deste
              processo. <br />
              Esse processo pode levar algum tempo, dependendo do volume de
              dados.
            </p>
            <br />
            <p>Deseja prosseguir?</p>
            {/* <p>
              Tem certeza que deseja excluir a empresa{" "}
              {maskCnpj(this.state.company.Cnpj)} -{" "}
              {this.state.company.RazaoSocial}?
            </p>
            <p>Todos os resultados serão excluídos!</p> */}
          </Modal>
        )}
      </div>
    );
  };

  filterOption(input, option) {
    if (input && option && option.props)
      return (
        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );

    return false;
  }

  render() {
    const { props } = this;
    const { company, disabledButton, moduloIcms } = this.state;

    return (
      <>
        {props.isFetching ? (
          <Loading text="Carregando dados da empresa" />
        ) : null}
        {this.renderModal()}
        <Form id="formCompany">
          <div className="products__data-company">
            <Card title="Dados" bordered={false} className="mb-3">
              <div className="row">
                <div className="form-group col-md-6">
                  <label className="col-form-label" htmlFor="RazaoSocial">
                    Razão Social*
                  </label>
                  <Input
                    className="form-control"
                    id="RazaoSocial"
                    name="RazaoSocial"
                    maxLength={100}
                    value={company.RazaoSocial}
                    onChange={this.handleChangeRazaoSocial}
                  />
                  <label className="col-form-label-error">
                    {this.state.errosRazaoSocial}
                  </label>
                </div>

                <div className="form-group col-md-3">
                  <label className="col-form-label" htmlFor="Cnpj">
                    CNPJ*
                  </label>
                  <Input
                    className="form-control"
                    id="Cnpj"
                    name="Cnpj"
                    value={maskCnpj(company.Cnpj || "")}
                    placeholder="__.___.___/____-__"
                    maxLength={18}
                    onChange={this.handleChangeCnpj}
                  />
                  <label className="col-form-label-error">
                    {this.state.errosCnpj}
                  </label>
                </div>

                <div className="form-group col-md-3">
                  <label className="col-form-label" htmlFor="Ie">
                    Insc. Estadual
                  </label>
                  <InputMask
                    className="form-control"
                    id="Ie"
                    maxLength={100}
                    name="Ie"
                    value={company.Ie}
                    onChange={this.handleChangeIe}
                  />
                </div>
              </div>

              <div className="row">
                <div className="form-group col-md-3">
                  <label className="col-form-label" htmlFor="Cep">
                    Cep
                  </label>
                  <InputMask
                    className="form-control"
                    id="Cep"
                    name="Endereco.Cep"
                    value={(company.Endereco && company.Endereco.Cep) || ""}
                    placeholder="_____-___"
                    mask="99999-999"
                    onChange={this.handleChangeCep}
                  />
                  <label className="col-form-label-error">
                    {this.state.errosCep}
                  </label>
                </div>

                <div className="form-group col-md-6">
                  <label className="col-form-label" htmlFor="Rua">
                    Rua
                  </label>
                  <Input
                    className="form-control"
                    id="Rua"
                    maxLength={100}
                    name="Endereco.Rua"
                    value={company.Endereco && company.Endereco.Rua}
                    onChange={this.handleChange}
                  />
                </div>

                <div className="form-group col-md-3">
                  <label className="col-form-label" htmlFor="Numero">
                    Número
                  </label>
                  <Input
                    className="form-control"
                    id="Numero"
                    name="Endereco.Numero"
                    maxLength={10}
                    onInput={this.maxLengthCheck}
                    type="number"
                    value={(company.Endereco && company.Endereco.Numero) || ""}
                    onChange={this.handleChange}
                  />
                </div>
              </div>
              <div className="row">
                <div className="form-group col-md-3">
                  <label className="col-form-label" htmlFor="Bairro">
                    Bairro
                  </label>
                  <Input
                    className="form-control"
                    id="Bairro"
                    name="Endereco.Bairro"
                    maxLength={100}
                    value={company.Endereco && company.Endereco.Bairro}
                    onChange={this.handleChange}
                  />
                </div>

                <div className="form-group col-md-3">
                  <label className="col-form-label" htmlFor="Municipio">
                    Município
                  </label>
                  <Input
                    className="form-control"
                    id="Municipio"
                    name="Endereco.Municipio"
                    maxLength={100}
                    value={company.Endereco && company.Endereco.Municipio}
                    onChange={this.handleChange}
                  />
                </div>

                <div className="form-group col-md-3">
                  <label className="col-form-label" htmlFor="Uf">
                    UF{moduloIcms ? "*" : ""}
                  </label>

                  <Select
                    className="ant-select--custom"
                    id="Uf"
                    name="Uf"
                    value={company.Uf}
                    onChange={(e) => this.handleSelectUF(e, "Uf")}
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      this.filterOption(input, option)
                    }
                  >
                    <Option value={null}>Selecione um estado</Option>
                    <Option value="AC">(AC) Acre</Option>
                    <Option value="AL">(AL) Alagoas</Option>
                    <Option value="AP">(AP) Amapá</Option>
                    <Option value="AM">(AM) Amazonas</Option>
                    <Option value="BA">(BA) Bahia</Option>
                    <Option value="CE">(CE) Ceará</Option>
                    <Option value="DF">(DF) Distrito Federal</Option>
                    <Option value="ES">(ES) Espírito Santo</Option>
                    <Option value="GO">(GO) Goiás</Option>
                    <Option value="MA">(MA) Maranhão</Option>
                    <Option value="MT">(MT) Mato Grosso</Option>
                    <Option value="MS">(MS) Mato Grosso do Sul</Option>
                    <Option value="MG">(MG) Minas Gerais</Option>
                    <Option value="PA">(PA) Pará</Option>
                    <Option value="PB">(PB) Paraíba</Option>
                    <Option value="PR">(PR) Paraná</Option>
                    <Option value="PE">(PE) Pernambuco</Option>
                    <Option value="PI">(PI) Piauí</Option>
                    <Option value="RR">(RR) Roraima</Option>
                    <Option value="RO">(RO) Rondônia</Option>
                    <Option value="RJ">(RJ) Rio de Janeiro</Option>
                    <Option value="RN">(RN) Rio Grande do Norte</Option>
                    <Option value="RS">(RS) Rio Grande do Sul</Option>
                    <Option value="SC">(SC) Santa Catarina</Option>
                    <Option value="SP">(SP) São Paulo</Option>
                    <Option value="SE">(SE) Sergipe</Option>
                    <Option value="TO">(TO) Tocantins</Option>
                  </Select>
                </div>

                <div className="form-group col-md-3">
                  <label className="col-form-label" htmlFor="Complemento">
                    Complemento
                  </label>
                  <Input
                    className="form-control"
                    id="Complemento"
                    name="Endereco.Complemento"
                    maxLength={100}
                    value={company.Endereco && company.Endereco.Complemento}
                    onChange={this.handleChange}
                  />
                </div>
              </div>
            </Card>

            <div className="products__data-company___footer">
              {(planoTeste === true || planoRecuperadorLimitado) ? (
                ""
              ) : (
                <Button type="danger" onClick={this.openModal}>
                  <Icon type="delete" />
                  Excluir Empresa
                </Button>
              )}
              <Button
                type="primary"
                disabled={disabledButton}
                loading={!!props.isFetching}
                onClick={this.handleSubmit}
                className="ml-2"
              >
                Salvar alterações
              </Button>
            </div>
          </div>
        </Form>
      </>
    );
  }
}

const loadingGetCompany = createLoadingSelector(["GET_COMPANY"]),
  loadingPutCompany = createLoadingSelector(["PUT_COMPANY"]);

const mapStateToProps = (state) => ({
  company: state.companies.data || {},
  status: state.companies.status,
  isFetching: loadingGetCompany(state) || loadingPutCompany(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getCompany,
      getCompanies,
      putCompany,
      excluirEmpresa,
      clearProductsPisCofings,
      clearProductsIcms,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Data));
